// extracted by mini-css-extract-plugin
export default {"tile_container":"B6","tile_img_container":"C6","not_recommended_label":"E6","modal_root":"F6","content":"G6","warning":"H6","x_mark":"I6","tile_img":"J6","tile_type":"K6","tile_product_title":"L6","tile_product_price":"M6","tile_descr_line":"N6","tile_descr_icon":"O6","info_icon":"P6","tile_descr_text":"Q6","tile_btns_container":"R6","info_container":"S6","info_text":"T6"};
    if(module.hot) {
      // 1711717535535
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  